import { useContext } from 'react';

import { FilterFieldContext } from '../contexts/FilterFieldContext.js';
import type { FilterFieldContextProps } from '../contexts/FilterFieldContext.types.js';

/** @internal */
export function useFilterFieldContext(): FilterFieldContextProps {
  return useContext(FilterFieldContext);
}
